import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";
import {  TipoFinanziamento } from '../models';


class DataTablesResponse {
    data: TipoFinanziamento[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Injectable({
    providedIn: "root"
})
export class TipoFinanziamentoService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}TipiFinanziamento/`;
    constructor(private http: HttpClient) { }

    getAllDt(dataTablesParameters: any) {
        return this.http.post<DataTablesResponse>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }
    getAll() {
        return this.http.get<TipoFinanziamento[]>(
            `${this.apiUrl}`
        );
    }
    insert(s: TipoFinanziamento) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    update(s: TipoFinanziamento) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    save(s:TipoFinanziamento){
        if (s.id)return this.update(s);
        return this.insert(s);
    }

}
